
export const AUTH = {
  LOGIN: "/admin-login",
  VERIFY_2FA: "/admin-login/verify-2fa",
  ENABLE_2FA: "/2fa/enable",
  CONFIRM_2FA: "/2fa/confirm",
  INVITE: "/invite/:token",
  SET_PASSWORD: "/set-password/:token",
  RESET_PASSWORD: "/reset-password",
} as const;

export const FEATURE_FLAGS = {
  LIST: "/feature-flags",
  DETAIL: "/feature-flags/:key",
} as const;

export const ADMIN = {
  LIST: "/adminlist",
  PERMISSIONS: "/permissions",
  ROLES: "/roles",
  INVITE: "admin-user/invite",
  RESEND_INVITE: "/admin-user/resend-invite/:admin",
  EDIT: "/edit/:id",
  DELETE: "/delete/:id",
  USER_PERMISSIONS: "/admin-with-permissions/:id",
  UPDATE_USER_PERMISSIONS: "/update-permissions/:id"
} as const;

export const USER = {
  LIST: "/users",
  PENDING_VA_REQUESTS: "/pending-va-request-users/:curr",
  DETAIL: "/users/:id",
  RESTRICT: "/restrict/:userId",
  MANUAL_REVIEW: "/users/:userId/manual-review",
  UPDATE_BVN_STATUS: "/user/update-bvn-status",
  UPDATE_DOCUMENT_VERIFICATION: "/update-user-document-verification-status",
  UPDATE_ADDRESS_VERIFICATION: "/users/:userId/update-address-verification",
  UPDATE_PASSPORT: "/users/:userId/update-passport",
  UPDATE_ACCOUNT_REQUEST: "/users/:userId/update-account-request/:requestId",
  EXPORT_ALL: "/users/export/all",
} as const;

export const EXCHANGE_RATE = {
  LIST: "/exchange-rates",
  DETAIL: "/exchange-rates/:id",
  WITH_FEES: "/exchange-rates/:id/with-fees",
  SETTINGS: "/settings",
  PAYOUT_TYPE: "/exchange-rates/:id/payout-type",
  TOGGLE_PAIR_STATUS: "/exchange-rates/:id/toggele-pair-status",
  EDIT_FEE: "/edit-exchange-fee",
  CHANNEL_FEES: "/channel-fees",
  CHANNEL_FEE_DETAIL: "/channel-fees/:id",
  UPDATE_CHANNEL_FEE: "/channel-fees/update/:id",
} as const;

export const TRANSACTION = {
  LIST: "/transactions/:transactionType",
  VERIFY_USER: "/transactions/verify-user",
  UPDATE_STATUS: "/transactions/:id/:statusType",
  UPDATE_PENDING: "/transactions/update-pending-transaction",
  MANUAL_DEPOSIT: "/transactions/manual-deposit",
  MANUAL_DEBIT: "/transactions/manual-debit",
  EXPORT: "/:path/export",
  EXPORT_WITH_TRAILING_SLASH: "/:path/export/",
} as const;

export const BAMBOO_TRANSFERS = {
  LIST: "/pending-bamboo-transfers",
  APPROVE: "/pending-bamboo-transfers/approve-transaction/:id",
  REJECT: "/pending-bamboo-transfers/reject-transaction/:id",
} as const;

export const CHARITY = {
  LIST: "/charities",
  DETAIL: "/charity/:id",
  DONORS: "/charity/:id/donors",
  CREATE: "/charity/",
} as const;

export const CURRENCY = {
  LIST: "/currencies",
  DETAIL: "/currencies/:id",
  STATUS: "/currencies/:id/status",
  UPDATE_LIMIT: "currencies/:currencyId",
} as const;

export const BENEFICIARY = {
  LIST: "/recipient/all",
  DETAIL: "/recipient/:id",
  UPDATE_SCREENING_STATUS: "/recipient/update-screening-status/:id",
} as const;

export const PROFILE = {
  DETAIL: "/profile",
  ACCOUNT_DETAILS: "/admin/account-details",
  CHANGE_PASSWORD: "/change-password",
} as const;

export const SANCTION = {
  FLAGGED_USERS: "/users/aml/flagged",
  AML_VERIFICATION: "/user/:id/aml-verification",
  EXPORT_FLAGGED: "/flagged-users/export",
} as const;

export const AUDIT = {
  TRAIL: "/audit-trails",
} as const;

export const DASHBOARD = {
  SUMMARY: "/dashboard",
} as const;

export const MARKETING = {
  OVERVIEW: "/marketing/overview",
  PARTNERS: "/marketing/partners",
  PARTNER_OPTIONS: "/marketing/partners/options",
  PARTNER_DETAIL: "/marketing/partners/:id",
  PARTNER_SUSPEND: "/marketing/partners/:id/suspend",
  PARTNER_REINSTATE: "/marketing/partners/:id/reinstate",
  PARTNER_PAYMENTS: "/marketing/partners/:id/payments",
  PARTNER_PAYMENT_REVERSE: "/marketing/partners/:id/payments/:paymentId/reverse",
  PARTNER_BRANCHES: "/marketing/partners/:id/branches",
  PARTNER_BRANCH: "/marketing/partners/:id/branches/:branchId",
  PARTNER_BRANCH_SIGN_IN_EMAIL:
    "/marketing/partners/:id/branches/:branchId/send-sign-in-email",
  PARTNER_ACTIVITY: "/marketing/partners/:id/activity",
  PARTNER_DEVICES: "/marketing/partners/:id/devices",
  PARTNER_DEVICES_REVOKE_ALL: "/marketing/partners/:id/devices/revoke-all",
  REVOKE_DEVICE: "/marketing/devices/:id/revoke",
  USER_SEARCH: "/marketing/users/search",
  USER_MATCH: "/marketing/users/match",
  BATCHES: "/marketing/batches",
  BATCHES_EXPORT: "/marketing/batches/export",
  BATCH_EMAIL_PREVIEW: "/marketing/batches/email-preview",
  BATCH_DETAIL: "/marketing/batches/:id",
  BATCH_RESEND_FAILED: "/marketing/batches/:id/resend-failed",
  VOUCHERS: "/marketing/vouchers",
  VOUCHERS_EXPORT: "/marketing/vouchers/export",
  VOUCHER_REVEAL: "/marketing/vouchers/:id/reveal",
  VOUCHER_RESEND: "/marketing/vouchers/:id/resend",
  DELIVERIES: "/marketing/deliveries",
  REDEMPTIONS: "/marketing/redemptions",
  REDEMPTIONS_EXPORT: "/marketing/redemptions/export",
} as const;
